<div *ngIf="backRouterLink" class="back-button" fxLayoutAlign="start center">
    <a fxLayout="row" fxLayoutAlign="start center" [routerLink]="backRouterLink">
        <span class="icon fa fa-arrow-left"></span>
        <span>Voltar</span>
    </a>
</div>
<div 
    class="internal-page-container" 
    [class.no-back-button]="!backRouterLink" 
    fxLayoutAlign="center center">
    <div fxFlex="500px" fxFlex.xs="100%">
        <ng-content select="[content]"></ng-content>
    </div>
</div>